export enum MessagingConfigTypeEnum {
  REMINDERS = 'REMINDERS',
  RECALLS = 'RECALLS',
  REGISTRATIONS = 'REGISTRATIONS', // no messages for messaging runs
  DAY_OF_REMINDERS = 'DAY_OF_REMINDERS',
  ORDER_NOTIFICATIONS = 'ORDER_NOTIFICATIONS',
  TEXT_REMINDERS = 'TEXT_REMINDERS', // these two are combined with reminders above
  PHONE_REMINDERS = 'PHONE_REMINDERS',
  RECALL_REPORTS = 'RECALL_REPORTS',
  SURVEYS = 'SURVEYS',
  RECALLS_BY_LAST_EXAM_DATE = 'RECALLS_BY_LAST_EXAM_DATE',
}

export function getMessagingConfigEnumAsNumber(
  value: MessagingConfigTypeEnum,
): number {
  return Object.keys(MessagingConfigTypeEnum).findIndex((key) => key === value);
}

export function getMessagingConfigEnumByIndex(
  value: number,
): MessagingConfigTypeEnum {
  return MessagingConfigTypeEnum[Object.keys(MessagingConfigTypeEnum)[value]];
}
